import { useTheme } from '@/components/ThemeProvider';
import { cn } from '@/lib/utils';
import { ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps extends ComponentPropsWithoutRef<'div'> {}

export default (props: IProps) => {
  const { ...attr } = props;
  const { t } = useTranslation();
  const { theme } = useTheme();
  const imgSrc = theme == 'light' ? '/icon/nodata-light.png' : '/icon/nodata-dark.png';
  return (
    <div className={cn('flex flex-col items-center text-center gap-y-[8px] py-[50px]', attr.className)}>
      <img src={imgSrc} className="w-[153px] h-[123px]" />
      <p className="text-secondaryTextColor text-[12px]">{t('Base.nodata')}</p>
    </div>
  );
};
